<template lang="pug">
.crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addRecord, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
  modal-order(:isStore="isStore")
  modal-session-order(:form="form", :inView="inView" @store="store")
  Loader(v-if="loader")
  .container-fluid
    vm-row( vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="left", vm-align="center", vm-w=5)
        details-requisition(@onSelected="onSelected" ref="detailRequisition")
      vm-col(class="middle_section" vm-justify="center", vm-align="center", vm-w=2)
        div(class="divider")
        vm-button( @click="addSupply()")
          vm-icon(icon="arrow-forward-outline")
        div(class="divider")
      vm-col(vm-justify="left", vm-w=5)
        details-purcharse-order
    vm-row(class="footer__order" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-type="flex" vm-justify="right", vm-align="center", vm-w=12)
        div
          vm-button(class="button_white" @click="endOrder()") {{ $t('requisitions_mailboxes.end_session')  }}
        div
          vm-button(:disabled="!hasDetails" @click="createdOrder()") {{ $t('requisitions_mailboxes.create_order')  }}
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Requisitions')
const DetailsRequisition = () => import('@/components/purchase-order/DetailsRequisition.vue')
const DetailsPurcharseOrder = () => import('@/components/purchase-order/DetailsPurcharseOrder.vue')
const ModalOrder = () => import('@/components/modals/ModalOrder.vue')
const ModalSessionOrder = () => import('@/components/modals/ModalSessionOrder.vue')
const Loader = () => import('@/components/aditionals/Loader.vue')
export default {
  name: 'CreatePurcharseOrders',
  components: {
    DetailsRequisition,
    DetailsPurcharseOrder,
    ModalSessionOrder,
    ModalOrder,
    Loader
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    requisitionProducts: [],
    storeProducts: [],
    inView: true,
    isStore: true,
    form: {}
  }),
  computed: {
    ...mapGetters(['purchaseOrder', 'requisition', 'loader']),
    hasDetails () {
      return this.purchaseOrder.details.length > 0
    }
  },
  created () {
    this.setLoaderVisible(true)
  },
  methods: {
    ...mapActions([
      'addProductToPurcharseOrder',
      'setModalOrderVisible',
      'setModalSessionOrderVisible',
      'setLoaderVisible'
    ]),
    onSelected (datas) {
      this.requisitionProducts = [...datas]
    },
    async addSupply () {
      await this.requisitionProducts.forEach(
        product => {
          if (product.supply_pending_quantity > 0 && product.supply_pending_quantity <= (product.supply_amount - product.supply_order_quantity)) {
            this.addProductToPurcharseOrder({
              ...product,
              unit_price: product.supply.price_buy
            })
          }
        }
      )
      this.$refs.detailRequisition.selected = []
    },
    endOrder () {
      if (this.requisition.products_to_send > 0) {
        this.setModalSessionOrderVisible(true)
      } else {
        this.$router.push({ name: 'requisitions-mailboxes' })
      }
    },
    createdOrder () {
      this.isStore = false
      this.setModalOrderVisible(true)
    },
    async store () {
      this.storeProducts = this.requisition.details.filter(e => e.supply_pending_quantity > 0)
      await this.storeProducts.forEach(
        product => this.addProductToPurcharseOrder({ ...product })
      )
      this.isStore = true
      this.setModalOrderVisible(true)
    }
  }
}
</script>
<style lang="scss">
.middle_section {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 15px;
  left: 43.5%;
  .divider {
    border-left: 1px solid #B1B1B1;
    height: 42vh;
  }
  .vm-button {
    background-color: #0059C1 !important;
    border-radius: 20px;
    width: 40px;
    height: 40px;
    margin: 15px;
  }
}
.footer__order {
  &__div {
    display: flex;
  }
  .vm-button  {
    border-radius: 10px;
  }
  .button_white {
    background-color: white !important;
    color: black !important;
    display: flex;
    border: 1px solid black;
    margin: 5px;
  }
}
</style>
